import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { ToolbarItemProps } from "./ToolbarItems";

interface DefaultAddButtonProps {
  onClick: () => void;
  roles?: string[];
}

export const defaultAddButton = ({
  onClick,
  text = "Add",
  icon = faPlus,
  roles = [],
}: DefaultAddButtonProps & Partial<ToolbarItemProps>) => ({
  text,
  icon,
  onClick,
  roles,
});
